const recently_viewed_section = document.querySelector('.recently-viewed');

const options = {
	rootMargin: '100px'
}

const observer = new IntersectionObserver(entry => {

    if (entry[0].isIntersecting == true) {

        observer.unobserve(recently_viewed_section)

        let rec_prods = localStorage.getItem('recentlyViewedProductHandles');
        if (rec_prods) {
            rec_prods_arr = rec_prods.replace("[","").replace("]","").split(',');

            let recently_viewed = document.querySelector('.recently-viewed-slider');

            rec_prods_arr.forEach(rec_prod => {
                let handle = rec_prod.replace(/"/g,'');

                fetch(window.Shopify.routes.root + `products/${handle}?view=card&section_id=pg-product-card`)
                  .then(response => {
                    if (response.ok) {
                      return response.text();
                    } else {
                      throw new Error("Error: " + response.status);
                    }
                  })
                  .then(data => {
                    const htmlDocument = new DOMParser().parseFromString(data, "text/html");
                    const productCard = htmlDocument.documentElement.querySelector("[product-card]");
                    const productExists = productCard.dataset.productId;
                    if (productExists == "") {
                      return;
                    }
                    let url = window.location.href + "#";
                    let swiper_slide = document.createElement("div");
                    swiper_slide.classList.add('swiper-slide');
                    swiper_slide.insertAdjacentHTML('afterbegin', productCard.outerHTML);

                    if (productCard !== url) {
                      recently_viewed.insertAdjacentHTML('afterbegin', swiper_slide.outerHTML);
                    }

                    const recent_swiper = new window.swiper('.recently-swiper', {
                      slidesPerView: 1.25,
                      spaceBetween: 20,
                      loop: true,
                      breakpoints: {
                        768: {
                          slidesPerView: 3,
                        },
                        1028: {
                          slidesPerView: 4,
                        },
                        1280: {
                          slidesPerView: 5,
                        },
                      },
                      navigation: {
                        nextEl: '.recently-viewed-slider-nav .next-btn',
                        prevEl: '.recently-viewed-slider-nav .prev-btn',
                      },
                      pagination: {
                        el: ".recently-viewed-slider-pagination.swiper-pagination",
                        type: "fraction",
                      },
                    });
                  })
                  .catch(error => {
                    console.error(error);
                  });

            });

        } else {
            document.querySelector('.recently-viewed #tab2').checked = true;
            document.querySelector('.recently-viewed #tab1 + label').style.display = 'none';
            document.querySelector('.recently-viewed .content1').style.display = 'none';
            document.querySelector('.recently-viewed input:checked + label').style.border= 'none';
            document.querySelector('.recently-viewed .recently-viewed-slider-nav').style.display = 'none';
            document.querySelector('.recently-viewed .collection-slider-nav').style.display = 'flex';
        }

        // Init section settings collection swiper
        const coll_swiper = new window.swiper('.best-sellers-swiper', {
            slidesPerView: 1.25,
            spaceBetween: 20,
            loop: true,
            breakpoints: {
              768: {
                slidesPerView: 3,
              },
              1028: {
                slidesPerView: 4,
              },
              1280: {
                slidesPerView: 5,
              },
            },
            navigation: {
              nextEl: '.collection-slider-nav .next-btn',
              prevEl: '.collection-slider-nav .prev-btn',
            },
            pagination: {
              el: ".collection-slider-pagination.recently-collection.swiper-pagination",
              type: "fraction",
            },
        });
    }


}, options)

observer.observe(recently_viewed_section);